<template>
    <UButton
        to="https://www.linkedin.com/company/agarwood-eco-capital"
        icon="i-bi-linkedin"
        :color="color"
        variant="outline"
        :size="size"
        :class="classColor"
        target="_blank" />

    <UButton
        to="https://www.facebook.com/people/Agarwood-Plantations/61573191835454/"
        icon="i-bi-facebook"
        :color="color"
        variant="outline"
        :size="size"
        :class="classColor"
        target="_blank" />

    <UButton
        to="https://www.instagram.com/agarwoodecocapital"
        icon="i-bi-instagram"
        :color="color"
        variant="outline"
        :size="size"
        :class="classColor"
        target="_blank" />
</template>

<script setup>
    const props = defineProps({
        size: {
            type: String,
            required: true
        },
        color: {
            type: String,
            required: true
        },
        class: {
            type: String,
            required: true
        },
        hover: {
            type: String,
            required: true
        }
    })

    const size = computed(() => {
        return `${props.size}`
    })

    const color = computed(() => {
        return `${props.color}`
    })

    const classColor = computed(() => {
        return `${props.class} hover:${props.hover}`
    })
</script>
